import type { CustomerStatus, EnrollmentStatus, LicenseStatus, LogAccess } from '@central/api';
import { color, font, type StatusTone } from '@central/ui';
import type { CSSProperties } from 'react';

export const mono: CSSProperties = { fontFamily: font.mono, fontSize: 13 };
export const muted: CSSProperties = { color: color.textMuted };

export const customerStatusChip: Record<CustomerStatus, { tone: StatusTone; label: string }> = {
  active: { tone: 'ok', label: 'Active' },
  suspended: { tone: 'warn', label: 'Suspended' },
  archived: { tone: 'unk', label: 'Archived' },
};

/** The server derives a license's status from its suspension and expiry. */
export const licenseStatusChip: Record<LicenseStatus, { tone: StatusTone; label: string }> = {
  active: { tone: 'ok', label: 'Active' },
  expiring: { tone: 'warn', label: 'Expiring' },
  expired: { tone: 'down', label: 'Expired' },
  suspended: { tone: 'down', label: 'Suspended' },
};

export const enrollmentLabel: Record<EnrollmentStatus, string> = {
  not_enrolled: 'Not enrolled',
  pending_approval: 'Pending approval',
  enrolled: 'Enrolled',
  revoked: 'Revoked',
};

export const logAccessLabel: Record<LogAccess, string> = {
  none: 'No one',
  owners: 'Owners',
  all: 'Every user',
};
